/**
 * Mixin: búsqueda por campo para las vistas de retiro independiente.
 * Replica el patrón de Table.vue (dropdown campo + input valor + botón Buscar).
 */

export const OPCIONES_BUSQUEDA = [
    { value: null,             text: 'Seleccionar campo...' },
    { value: 'id',             text: 'N° Solicitud' },
    { value: 'documento',      text: 'Documento paciente' },
    { value: 'nombre_completo',text: 'Nombre paciente' },
];

/**
 * Construye el filtro de búsqueda según el campo seleccionado.
 * - id        → equals (búsqueda exacta)
 * - resto     → iLike  (búsqueda parcial)
 */
export function buildFiltrosBusqueda(campo, valor) {
    if (!campo || !valor || !valor.trim()) return [];
    const v = valor.trim();
    if (campo === 'id') {
        return [{ id: { equals: v } }];
    }
    return [{ [campo]: { iLike: `%${v}%` } }];
}
